import * as React from "react";
import * as P230Messages from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { StudyScheduleSession, Subject } from "webportalclient";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { ConfigureP230Device, ConfigureP230HomeSpirometrySession } from "./P230HomeSpirometryConfiguration";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import { useAboutContextProvider } from "../../../Core/AboutContextProvider";

interface P230HomeSpirometryLocalConfigureProps {
    subject: Subject;
    deviceSelected: Device;
    sessionScheduleItems: StudyScheduleSession[];
    onError: (message: string) => void;
    onNext: (redirect?: string) => void;
}

export const P230HomeSpirometryLocalConfigure = ({ subject, deviceSelected, sessionScheduleItems, onError, onNext }: P230HomeSpirometryLocalConfigureProps) => {
    const client = useWebPortalApiClient();
    const [status, setStatus] = React.useState(P230Messages.ConfiguringDevice);
    const { study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();
    const { about } = useAboutContextProvider();

    React.useEffect(() => {
        const localConfigure = async () => {
            const result = await ConfigureP230Device(client.client, legacyClient, study, subject, deviceSelected, sessionScheduleItems, about.UpdateServiceUri, undefined, undefined, setStatus, onError);

            if (result === false)
                return;

            setStatus(P230Messages.StartingHomeSpirometrySession);
            const analysisSetResult = await ConfigureP230HomeSpirometrySession(client.client, deviceSelected.serial, subject, sessionScheduleItems[0], true);

            onNext(`/spirometry/siteAnalysis/${analysisSetResult.id}/edit`);
        }

        localConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message={status} />
        </div>
    );
}
